module.exports = __webpack_public_path__ + "img/photo-12.088d1e20.jpg";